<template>
  <el-card>
    <el-alert title="导入失败" type="error" effect="dark" v-if="showImportError" @close="showImportError = false">
      <div v-for="(item, index) in importError" :key="index">{{item}}</div>
    </el-alert>

    <el-alert title="导入完成" type="warning" effect="dark" v-if="showImportHasEmpty" @close="showImportHasEmpty =
    false">
      <div>已为您剔除文档中序列号或型号为空的数据</div>
    </el-alert>

    <div slot="header">
      <h1 class="has-operation">
        <span>序列号列表</span>
      </h1>
      <div class="header-index-content">
        <p>请下载乐器编码导入模板，按照表格模板完善乐器编码文件导入</p>
        <p class="content-link">
          <a href="javascript:;" @click="downloadTemplate">
            <icon name="arrow_downward" />下载导入模板
          </a>
          <uploader
          target="serials-import"
          @success="handleImportSuccess"
          @error="handleImportError"
          accept=".xlsx,.xls,.csv"
          >
            <a href="javascript:;">
              <icon name="arrow_upward" />导入
            </a>
          </uploader>
        </p>
      </div>
    </div>

    <el-form inline :model="query" class="filter-form">
      <el-form-item label="序列号:">
        <el-input v-model="query.number" placeholder="请输入序列号" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable placeholder="请选择">
          <el-option
            v-for="item in $enums.serialStatus.getList()"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table class="table block" :data="collection" v-loading="loading">
      <el-table-column prop="number" label="序列号" />
      <el-table-column label="型号">
        <template slot-scope="scope">
          {{scope.row.serial_model.name}}
        </template>
      </el-table-column>
      <el-table-column prop="number" label="状态" :formatter="formatStatus"/>
      <el-table-column prop="createdAt" label="添加时间" />
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-link type="primary" @click="showEdit(scope.row)" style="margin-right: 10px;">编辑</el-link>
          <el-link type="danger" @click="remove(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
    <el-dialog title="编辑序列号" :visible.sync="dialogFormVisible">
      <el-form :model="editSerial" :rules="rules" ref="form">
        <el-form-item label="序列号" label-width="120px" prop="number">
          <el-input v-model="editSerial.number" autocomplete="off" style="width: 300px;"></el-input>
        </el-form-item>

        <el-form-item label="型号" label-width="120px" prop="serialModelId">
          <el-select v-model="editSerial.serialModelId" filterable placeholder="请选择型号" style="width: 300px;">
            <el-option
              v-for="item in serialModels"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="序列号状态" label-width="120px" prop="status">
          <el-select v-model="editSerial.status" placeholder="请选择" style="width: 300px;">
            <el-option
              v-for="item in $enums.serialStatus.getList()"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash'
  const { mapGetters } = createNamespacedHelpers('serials')

  export default {
    data() {
      return {
        loading: false,
        query: {
          number: '',
          status: '',
        },
        importError: '',
        showImportError: false,
        showImportHasEmpty: false,
        dialogFormVisible: false,
        editSerial : {},
        serialModels: [],
        rules: {
          number : [{ required: true, message: '请输入序列号', trigger: 'blur' }],
          serialModelId : [{ required: true, message: '请选择型号', trigger: 'blur' }],
          status : [{ required: true, message: '请选择序列号状态', trigger: 'blur' }],
        }
      }
    },
    computed: {
      ...mapGetters(['collection', 'total', 'pagination'])
    },
    methods: {
      async queryCollection({ pagination = { limit: 20 } } = {}) {
        let query = {
          ...this.query,
        }

        try {
          this.loading = true
          await this.$store.dispatch('serials/collection', { query, pagination })
        } finally {
          this.loading = false
        }
      },
      async remove(serial) {
        await this.$confirm('确认要删除此序列号吗？')
        try {
          this.loading = true
          await this.$store.dispatch('serials/remove', { id:serial.id })
        } finally {
          this.loading = false
          this.queryCollection()
          this.$message.success('已删除：“'+serial.number+'”序列号')
        }

      },
      formatStatus (serial) {
        return this.$enums.serialStatus.label(serial.status)
      },
      async downloadTemplate() {
        this.$linkHelper.redirect('serials-template')
      },
      async showEdit(model) {
        this.editSerial = _.cloneDeep(model)
        delete this.editSerial.serial_model
        await this.getSerialModels()
        this.dialogFormVisible = true
      },
      //编辑提交方法
      async submitEdit() {
        await this.$formHelper.promisedValidate(this.$refs.form)
        await this.$store.dispatch('serials/update', this.editSerial)
        await this.queryCollection()
        this.dialogFormVisible = false
        this.$message.success('编辑型号成功')
      },
      handleImportSuccess(res) {
        if(res.count > 0) {
          this.$message.success(`成功导入了${res.count}条数据`)
        }
        if(res.error.length > 0) {
          this.importError = res.error
          this.showImportError = true
        }

        if(res.emptyError > 0) {
          this.showImportHasEmpty = true
        }
        this.queryCollection()
      },
      handleImportError(error) {
        this.$message.error('导入失败了：' + error.message)
      },
      async getSerialModels() {
        const { collection } = await this.$store.dispatch('serialModel/collection', { pagination: {limit: 1000} })
        this.serialModels = collection
      }
    },
    async mounted() {
      await this.queryCollection()
    }
  }
</script>
